import React, { FC } from "react";

import { Icon } from "@/components/Icon";
import { Text } from "@/components/Text";
import { Flex } from "@/eworkitComponents";

import "./_filter-badge.scss";

interface IFilterBadgeProps {
  icon?: string;
  label: string;
  rightIcon?: string;
  onClick: () => void;
}

export const FilterBadge: FC<IFilterBadgeProps> = ({ icon, label, rightIcon, onClick }) => {
  const baseClass = "filter-badge";

  return (
    <div onClick={onClick}>
      <Flex className={baseClass} direction="row" align="center" innerMargin="sm">
        {icon && <Icon className={`${baseClass}__icon`} icon={icon} color="background-card" size="sm" />}
        <Text color="background-card" size="md">
          {label}
        </Text>
        {rightIcon && <Icon icon={rightIcon} color="grey4" size="md" />}
      </Flex>
    </div>
  );
};
